<div>
  <!-- Skeleton Loader -->
  @if (galleriesLoading) {
    <div class="skeleton-loader">
      <div class="d-flex justify-content-between align-items-center py-3" style="border-bottom: 1px solid #e9ecef;">
        <div class="skeleton" style="width: 160px; height: 28px;"></div>
        <div class="skeleton" style="width: 140px; height: 36px; border-radius: 6px;"></div>
      </div>
      <div class="d-flex gap-4 my-3 flex-wrap">
        @for (i of [1,2,3,4]; track i) {
          <div class="skeleton" style="width: 220px; height: 28px; border-radius: 20px;"></div>
        }
      </div>
      <div class="skeleton" style="width: 100%; height: 40px; border-radius: 6px; margin-bottom: 12px;"></div>
      <div class="d-flex py-2" style="border-bottom: 1px solid #e9ecef; gap: 16px;">
        @for (i of [1,2,3,4,5,6,7]; track i) {
          <div class="skeleton" style="width: 14%; height: 18px;"></div>
        }
      </div>
      @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
        <div class="d-flex py-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
          @for (j of [1,2,3,4,5,6,7]; track j) {
            <div class="skeleton" style="width: 14%; height: 16px;"></div>
          }
        </div>
      }
    </div>
  }

  @if (!galleriesLoading) {
    <div class="row">
      <div class="col-md-12">
        <p-toolbar>
          <div class="p-toolbar-group-start" style="font-size: x-large">
            {{ 'galleries.viewGalleries' | transloco }}
          </div>
          <div class="p-toolbar-group-end">
            <button type="button" pButton [label]="'galleries.createGallery' | transloco" class="p-button ms-2 p-button-outlined"
            (click)="showGalleryDialog()"></button>
          </div>
        </p-toolbar>
      </div>
    </div>
    <div class="row my-2 p-1">
      <div class="col d-flex justify-content-start p-2">
        <div class="d-flex justify-content-end align-items-center">
          <div class="d-flex flex-column align-items-start me-3">
            <div class="d-flex align-items-center">
              <p-inputSwitch class="mt-1" [(ngModel)]="filterByArtflow" (onChange)="getFilteredGalleries()"></p-inputSwitch>
              <span class="ms-2 fw-semibold">{{ 'galleries.filterByArtflowProAdmin' | transloco }}</span>
            </div>
          </div>
          <div class="d-flex flex-column align-items-start me-3">
            <div class="d-flex align-items-center">
              <p-inputSwitch class="mt-1" [(ngModel)]="filterByFreeTrial" (onChange)="getFilteredGalleries()"></p-inputSwitch>
              <span class="ms-2 fw-semibold">{{ 'galleries.filterFreeTrialGalleries' | transloco }}</span>
            </div>
          </div>
          <div class="d-flex flex-column align-items-start me-3">
            <div class="d-flex align-items-center">
              <p-inputSwitch class="mt-1" [(ngModel)]="filterByStripe" (onChange)="getFilteredGalleries()"></p-inputSwitch>
              <span class="ms-2 fw-semibold">{{ 'galleries.filterByStripeSubscription' | transloco }}</span>
            </div>
          </div>
          <div class="d-flex flex-column align-items-start ms-2">
            <div class="d-flex align-items-center">
              <p-inputSwitch class="mt-1" [(ngModel)]="filterByAppleInAppPurchase" (onChange)="getFilteredGalleries()"></p-inputSwitch>
              <span class="ms-2 fw-semibold">{{ 'galleries.filterInAppAppleSubscription' | transloco }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive mt-3">
      <!-- PrimeNG table here: [(selection)]="galleryItems"  -->
      <p-table #dt [value]="galleries" dataKey="Id" [rowHover]="true"
        styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="[ 'BusinessName', 'Name', 'Email', 'PhoneNumber']"
        [paginator]="galleries.length > 15" [rows]="40" [reorderableColumns]="true" [resizableColumns]="false"
        selectionMode="single">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <div class="row">
              <div class="col-12 text-right">
                <div
                  class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                  <button type="button"
                    class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                    <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                  </button>
                  <input type="text"
                    class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                  (input)="
                    dt.filterGlobal($any($event.target).value, 'contains')
                  " [placeholder]="'galleries.searchGallery' | transloco" />
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-rowIndex="rowIndex" let-rowData>
            <tr>
              <th [pSortableColumn]="'Name'">
                {{ 'galleries.galleryNameHeader' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'Email'">
                {{ 'galleries.email' | transloco }} <p-sortIcon [field]="'Email'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'PhoneNumber'">
                {{ 'galleries.phoneNumber' | transloco }} <p-sortIcon [field]="'PhoneNumber'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'GalleryType'">
                {{ 'galleries.galleryType' | transloco }}<p-sortIcon [field]="'GalleryType'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'ABN'">
                {{ 'galleries.abn' | transloco }} <p-sortIcon [field]="'ABN'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'CreatedDate'">
                {{ 'galleries.created' | transloco }} <p-sortIcon [field]="'CreatedDate'"></p-sortIcon>
              </th>
              <th>{{ 'galleries.actions' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
            <tr>
              <td>
                <div class="d-flex form-group align-items-center">
              <img [src]="
                  rowData.GalleryImgUrl
                    ? rowData.GalleryImgUrl
                    : 'assets/images/No-Image.png'
                " class="rounded-circle me-1" style="width: 15px; height: 15px; object-fit: cover" />
                    <!-- <span class="">{{ rowData.BusinessName }}</span> -->
                    <div class="d-flex align-items-center">
                      <div class="text-capitalize me-1">{{ rowData.BusinessName }}</div>
                      @if (rowData.IsPro) {
                        <!-- Dynamic background color for Pro badge -->
                        @if (rowData.IsPro) {
                          <span class="badge"
                            [ngStyle]="{'background-color': '#178d9b', 'color': 'white'}">
                            {{ 'galleries.pro' | transloco }}
                          </span>
                        }
                      }
                      <!-- <span *ngIf="!rowData.IsProByPlatform" class="badge bg-secondary">Free Account</span> -->
                    </div>
                  </div>
                </td>
                <td>
                  @if (rowData.Email) {
                    <div>
                      <i class="fa fa-envelope-o me-1"></i> {{ rowData.Email }}
                    </div>
                  }
                </td>
                <td>
                  @if (rowData.PhoneNumber) {
                    <div>
                      <i class="fa fa-phone me-1"></i> {{ rowData.PhoneNumber }}
                    </div>
                  }
                </td>
                <td>
                  @if (rowData.GalleryType) {
                    <div>{{ rowData.GalleryType }}</div>
                  }
                </td>
                <td>
                  {{ rowData.ABN }}
                </td>
                <td>
                  {{ rowData.CreatedDate | date : "dd/MM/yyyy HH:mm" }}
                </td>
                <td>
                  <div [ngClass]="{'justify-content-end': true}" class="d-flex align-items-center">
                    <!-- Show "up" button for users who are not Pro -->
                    @if (!rowData.IsPro) {
                      <button pButton class="p-button-sm"
                        [style.backgroundColor]="'#ffffff'" [style.color]="'#f79421'" [style.borderColor]="'#f79421'"
                        [label]="'galleries.upgrade' | transloco" icon="pi pi-shield"
                        [pTooltip]="'galleries.upgradeToProAccount' | transloco" tooltipPosition="top" (click)="switchToProAccount(rowData.Id, true)">
                      </button>
                    }
                    @if (rowData.IsPro && rowData.ProBySource === proBySource.Artflow) {
                      <button pButton class="p-button-sm"
                        [style.backgroundColor]="'#ffffff'" [style.color]="'#178d9b'" [style.borderColor]="'#178d9b'"
                        [label]="'galleries.downgrade' | transloco" icon="pi pi-chevron-left"
                        [pTooltip]="'galleries.downgradeToFreeAccount' | transloco" tooltipPosition="top" (click)="switchToProAccount(rowData.Id,false)">
                      </button>
                    }
                    <div class="justify-content-end d-flex">
                      <!-- Edit Button -->
                      <button pButton (click)="editGallery(rowData.Id)" class="p-button p-button-sm ms-2 p-button-outlined"
                        icon="pi pi-pencil" size="small">
                      </button>
                      <!-- Delete Button -->
                      <button pButton (click)="deleteGallery(rowData.Id)"
                        class="p-button-danger p-button-sm ms-2 p-button-outlined" icon="pi pi-trash" size="small">
                      </button>
                      <!-- Switch Account Button -->
                      <button pButton icon="fa fa-sign-in" class="p-button-sm ms-2 p-button-outlined"
                        (click)="switchAccount(rowData)" [pTooltip]="'galleries.switchAccount' | transloco" tooltipPosition="top">
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="7">
                  <div class="text-center">{{ 'galleries.noRecordsFound' | transloco }}</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
    <!-- Gallery Dialog -->
    <p-dialog [header]="isEditMode ? ('galleries.editGallery' | transloco) : ('galleries.addGallery' | transloco)" [(visible)]="galleryDialogVisible" [modal]="true"
      [style]="{ width: '660px' }" (onHide)="closeDialog()">
      <form class="form-horizontal" #galleryForm="ngForm">
        <div class="form-body">
          <div class="row p-0">
            <p-tabView [(activeIndex)]="selectedTabIndex">
              <p-tabPanel [header]="'galleries.galleryInformation' | transloco">
                <div class="col-12">
                  <div class="d-flex justify-content-end my-2">
                    <button pButton type="button" class="mt-2 p-button-outlined" (click)="submitGalleryForm()"
                      icon="pi pi-save" [label]="'galleries.saveChanges' | transloco"
                    [disabled]="!galleryItems.FirstName || !galleryItems.LastName || !galleryItems.BusinessName  || !galleryItems.Email"></button>
                  </div>
                  <div class="row mt-2">
                    <div class="col-4"></div>
                    <div class="col-4">
                      <div class="form-group">
                        @if (!galleryItems.GalleryImgUrl) {
                          <!-- <label for="formFile" class="form-label">Gallery Logo</label> -->
                          <!-- <input class="form-control" type="file" id="formFile" name="LogoFile"
                          (change)="onFileSelected($event)" /> -->
                          <p-fileUpload #fileUpload name="productImageFile" accept="image/*"
                            (onSelect)="onFileSelected($event.files)" [chooseLabel]="'galleries.select' | transloco" [auto]="true" [previewWidth]="70"
                            styleClass="upload_image" [multiple]="false" mode="basic">
                            <!-- <ng-template pTemplate="toolbar">
                            <div class="mt-2">Drag and drop file here</div>
                          </ng-template> -->
                        </p-fileUpload>
                      }

                      @if (galleryItems.GalleryImgUrl) {
                        <div class="position-relative d-inline-block p-2 rounded shadow">
                          <img [src]="galleryItems.GalleryImgUrl" class="rounded-circle"
                            style="width: 100px; height: 100px" alt="Gallery Image" />
                            <div class="position-absolute top-0 end-0">
                              <button type="button" class="btn btn-danger btn-sm p-button-danger p-button-outlined"
                                (click)="removeImg()">
                                <i class="fa fa-times"></i>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-4"></div>

                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label for="FirstName" class="form-label">{{ 'galleries.galleryFirstName' | transloco }}</label>
                          <input type="text" class="form-control" [(ngModel)]="galleryItems.FirstName"
                            [placeholder]="'galleries.enterUserName' | transloco" name="FirstName" id="FirstName" required />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label for="LastName" class="form-label">{{ 'galleries.galleryLastName' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="galleryItems.LastName"
                              [placeholder]="'galleries.enterUserName' | transloco" name="LastName" id="LastName" required />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="form-group">
                        <label for="UserName" class="form-label">User Name</label>
                        <input type="text" class="form-control" [(ngModel)]="galleryItems.Name" placeholder="Enter User name"
                          name="UserName" id="UserName" required />
                        </div> -->

                        <div class="form-group">
                          <label for="galleryName" class="form-label">{{ 'galleries.galleryName' | transloco }}</label>
                          <input type="text" class="form-control" [(ngModel)]="galleryItems.BusinessName"
                            [placeholder]="'galleries.enterGalleryName' | transloco" name="galleryName" id="galleryName" required />
                          </div>

                          <div class="form-group mt-2">
                            <label class="form-label">{{ 'galleries.galleryType' | transloco }}</label>
                            <p-dropdown [options]="items" [(ngModel)]="galleryItems.GalleryType" [placeholder]="'galleries.selectGalleryType' | transloco"
                            name="galleryType" [style]="{ width: '100%' }"></p-dropdown>
                          </div>

                          <div class="form-group mt-2">
                            <label for="artType" class="form-label">{{ 'galleries.changeRuleSets' | transloco }}</label>
                            <p-dropdown [options]="subscriptionRules" [(ngModel)]="galleryItems.SubscriptionRuleSetId"
                            [placeholder]="'galleries.selectRuleset' | transloco" name="subscriptionRules" [style]="{'width':'100%'}"></p-dropdown>
                            <div class="text-secondary">{{ 'galleries.rulesetWarning' | transloco }}</div>
                          </div>

                          <div class="col-6">
                            <div class="form-group mt-2">
                              <label class="form-label">{{ 'galleries.email' | transloco }}</label>
                              <input type="email" class="form-control" [(ngModel)]="galleryItems.Email"
                                [placeholder]="'galleries.enterEmailAddress' | transloco" name="galleryEmail" />
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-group mt-2">
                                <label class="form-label">{{ 'galleries.phoneNumber' | transloco }}</label>
                                <input type="tel" class="form-control" [(ngModel)]="galleryItems.PhoneNumber"
                                  [placeholder]="'galleries.enterPhoneNumber' | transloco" name="galleryPhoneNumber" />
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <div class="form-group mt-2">
                                  <label class="form-label">{{ 'galleries.department' | transloco }}</label>
                                  <input type="text" class="form-control" [(ngModel)]="galleryItems.Department"
                                    [placeholder]="'galleries.enterDepartment' | transloco" name="galleryDepartment" />
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="form-group mt-2">
                                    <label class="form-label">{{ 'galleries.website' | transloco }}</label>
                                    <input type="url" class="form-control" [(ngModel)]="galleryItems.Website"
                                      [placeholder]="'galleries.enterGalleryWebsite' | transloco" name="Website" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <!-- Facebook Link -->
                                    <div class="form-group mt-2">
                                      <label class="form-label" for="FacebookLink">{{ 'galleries.facebookLink' | transloco }}</label>
                                      <input id="FacebookLink" pInputText [placeholder]="'galleries.facebookLink' | transloco" class="form-control form-control-sm"
                                        [(ngModel)]="galleryItems.FacebookLink" name="FacebookLink" required />
                                      </div>
                                    </div>
                                    <div class="col-6">
                                      <!-- Instagram Link -->
                                      <div class="form-group mt-2">
                                        <label class="form-label" for="InstagramLink">{{ 'galleries.instagramLink' | transloco }}</label>
                                        <input id="InstagramLink" pInputText [placeholder]="'galleries.instagramLink' | transloco"
                                          class="form-control form-control-sm" [(ngModel)]="galleryItems.InstagramLink" name="InstagramLink"
                                          required />
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          <!-- Linkedin Link -->
                                          <div class="form-group mt-2">
                                            <label class="form-label" for="LinkedinLink">{{ 'galleries.linkedinLink' | transloco }}</label>
                                            <input id="LinkedinLink" pInputText [placeholder]="'galleries.linkedinLink' | transloco"
                                              class="form-control form-control-sm" [(ngModel)]="galleryItems.LinkedinLink" name="LinkedinLink"
                                              required />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="p-2">
                                      <div class="form-group">
                                        <label for="saleType" class="form-label">{{ 'galleries.saleType' | transloco }}</label>
                                        <div class="d-flex justify-content-start">
                                          <div class="d-flex align-items-center">
                                            <input type="radio" name="GallerySaleType" value="Consignment"
                                              [(ngModel)]="galleryItems.GallerySaleType" id="saleTypeAsConsignment" />
                                              <label for="saleTypeAsConsignment" class="ms-1">{{ 'galleries.consignment' | transloco }}</label>
                                            </div>
                                            <div class="d-flex align-items-center ms-3">
                                              <input type="radio" name="GallerySaleType" value="WholeSale"
                                                [(ngModel)]="galleryItems.GallerySaleType" id="saleTypeAsWholeSale" />
                                                <label for="saleTypeAsWholeSale" class="ms-1">{{ 'galleries.wholesale' | transloco }}</label>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="row mt-2">
                                            <div class="col-6">
                                              @if (galleryItems.GallerySaleType == 'Consignment') {
                                                <div class="form-group me-3">
                                                  <label for="galleryCommission" class="form-label">{{ 'galleries.commission' | transloco }}</label>
                                                  <p-dropdown [options]="commissionOptions" [(ngModel)]="galleryItems.CommissionPercentage"
                                                  name="galleryCommission" [style]="{ width: '100%' }"></p-dropdown>
                                                </div>
                                              }
                                            </div>
                                            <div class="col-6">
                                              <div class="form-group me-3">
                                                <label for="gallerySalesTax" class="form-label">{{ 'galleries.salesTaxPercent' | transloco }}</label>
                                                <input type="number" class="form-control w-100" [(ngModel)]="galleryItems.SalesTaxPercentage"
                                                  min="10" max="100" name="gallerySalesTax" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row mt-2">
                                              <div class="col-6">
                                                <div class="form-group me-3 mb-5">
                                                  <label for="terms" class="form-label mt-1">{{ 'galleries.terms' | transloco }}</label>
                                                  <p-dropdown [options]="terms" [(ngModel)]="galleryItems.Terms" [placeholder]="'galleries.selectTerms' | transloco"
                                                  name="terms" [style]="{ width: '100%' }"></p-dropdown>
                                                </div>
                                              </div>
                                              <div class="col-6">
                                                <div class="form-group">
                                                  <label for="galleryABN" class="form-label">{{ 'galleries.abn' | transloco }}</label>
                                                  <input type="text" class="form-control" [(ngModel)]="galleryItems.ABN" name="galleryABN" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row mt-2">
                                              <div class="form-group">
                                                <p-checkbox name="addGST" [binary]="true" [label]="'galleries.addGst' | transloco"
                                                [(ngModel)]="galleryItems.AddGST"></p-checkbox>
                                              </div>
                                              @if (galleryItems.AddGST) {
                                                <div class="form-group">
                                                  <label for="gstId" class="form-label">{{ 'galleries.gstId' | transloco }}</label>
                                                  <input type="text" class="form-control" [(ngModel)]="galleryItems.GstId" [placeholder]="'galleries.gstId' | transloco"
                                                    name="gstId" id="gstId" />
                                                  </div>
                                                }
                                              </div>
                                              <div class="mt-2">
                                                <p-panel [header]="'galleries.galleryAddresses' | transloco">
                                                  <app-view-gallery-address [galleryAddresses]="galleryItems.GalleryAddresses" [galleryId]="galleryId"
                                                  (onAddressChanged)="onGalleryItemsChange($event)"></app-view-gallery-address>
                                                </p-panel>
                                              </div>
                                            </div>
                                          </p-tabPanel>
                                          <!-- <div class="form-group mt-3 mb-2" *ngIf="authConfig.IsAdministrator"> -->
                                          @if (renderGalleryStaff) {
                                            <p-tabPanel [header]="'galleries.galleryStaff' | transloco">
                                              <app-gallery-staff [galleryId]="galleryItems.Id"></app-gallery-staff>
                                            </p-tabPanel>
                                          }
                                        <!-- </div> -->
                                        @if (isEditMode) {
                                          <p-tabPanel [header]="'galleries.connectedArtist' | transloco">
                                            <div class="page-innder-body portlet light">
                                              <div class="portlet-body">
                                                <div class="table-toolbar">
                                                  <div class="row">
                                                    <div class="col-md-12">
                                                      <p-toolbar>
                                                        <div class="p-toolbar-group-start" style="font-size: x-large">
                                                          {{ 'galleries.yourConnectedArtists' | transloco }}
                                                        </div>
                                                        <div class="p-toolbar-group-end"></div>
                                                      </p-toolbar>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="table-responsive mt-3">
                                                  <p-table #dt [value]="connectedArtist" dataKey="gallery-connection" [rowHover]="true"
                    styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="[
                      'Name',
                      'Email',
                      'PhoneNumber',
                      'BusinessName'
                    ]" selectionMode="single" [paginator]="true" [rows]="10" [reorderableColumns]="true"
                                                    [resizableColumns]="false">
                                                    <ng-template pTemplate="caption">
                                                      <div class="table-header">
                                                        <div class="row">
                                                          <div class="col-md-6 text-right">
                                                            <div
                                                              class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                                                              <button type="button"
                                                                class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                                                                <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                                                              </button>
                                                              <input type="text"
                                                                class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                                (input)="
                                  dt.filterGlobal(
                                    $any($event.target).value,
                                    'contains'
                                  )
                                " [placeholder]="'galleries.search' | transloco" />
                                                              </div>
                                                            </div>
                                                            <div class="col-md-6 text-left"></div>
                                                          </div>
                                                        </div>
                                                      </ng-template>
                                                      <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
                                                        <tr>
                                                          <th [pSortableColumn]="'Name'">
                                                            {{ 'galleries.artist' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon>
                                                          </th>
                                                          <th class="text-center" [pSortableColumn]="'Accepted'" style="width: 180px">
                                                            {{ 'galleries.connected' | transloco }}
                                                            <p-sortIcon [field]="'Connected'"></p-sortIcon>
                                                          </th>
                                                          <th class="text-center">{{ 'galleries.social' | transloco }}</th>
                                                        </tr>
                                                      </ng-template>
                                                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
                                                        <tr>
                                                          <td>
                                                            <div class="d-flex">
                            <img [src]="
                                rowData.ImgUrl
                                  ? rowData.ImgUrl
                                  : 'assets/images/No-Image.png'
                              " width="45" class="rounded-circle cursor-pointer" />
                                                                <div class="ms-2">
                                                                  <div class="d-flex justify-content-start align-items-center">
                                                                    <a href="javascript:void(0);" (click)="navigateToViewArtist(rowData)">
                                                                      {{ rowData.Name }}
                                                                    </a>
                                                                    @if (
                                                                      rowData.IsInitiatedByArtist &&
                                                                      rowData.IsInviteAccepted
                                                                      ) {
                                                                      <i class="fa fa-check-circle text-success ms-2" [title]="'galleries.accepted' | transloco"></i>
                                                                    }
                                                                    @if (
                                                                      !rowData.IsInitiatedByArtist &&
                                                                      !rowData.IsInviteAccepted
                                                                      ) {
                                                                      <i class="fa fa-check-circle text-danger ms-2" [title]="'galleries.send' | transloco"></i>
                                                                    }
                                                                    @if (
                                                                      rowData.IsInitiatedByArtist &&
                                                                      !rowData.IsInviteAccepted
                                                                      ) {
                                                                      <i class="fa fa-clock-o text-danger ms-2" [title]="'galleries.pending' | transloco"></i>
                                                                    }
                                                                  </div>
                                                                  <div class="text-muted small">
                                                                    {{ rowData.Email }}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </td>
                                                            <td>
                                                              {{
                                                              rowData.InvitationAccepted
                                                              | date : "dd/MM/yyyy HH:mm"
                                                              }}
                                                            </td>
                                                            <td>
                                                              <div class="d-flex align-items-center">
                            <a [href]="
                                rowData.Website
                                  ? rowData.Website
                                  : 'javascript:void(0);'
                              ">
                                                                  <i class="fa fa-globe text-muted"></i>
                                                                </a>
                            <a [href]="
                                rowData.BusinessFacebookLink
                                  ? rowData.BusinessFacebookLink
                                  : 'javascript:void(0);'
                              " class="ms-1">
                                                                  <i class="fa fa-facebook text-muted"></i>
                                                                </a>
                            <a [href]="
                                rowData.BusinessInstagramLink
                                  ? rowData.BusinessInstagramLink
                                  : 'javascript:void(0);'
                              " class="ms-1">
                                                                  <i class="fa fa-instagram text-muted"></i>
                                                                </a>
                            <a [href]="
                                rowData.BusinessLinkedinLink
                                  ? rowData.BusinessLinkedinLink
                                  : 'javascript:void(0);'
                              " class="ms-1">
                                                                  <i class="fa fa-linkedin text-muted ms-1"></i>
                                                                </a>
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="emptymessage">
                                                          <tr>
                                                            <td [attr.colspan]="6">
                                                              <div class="text-center">{{ 'galleries.noConnectionsFound' | transloco }}</div>
                                                            </td>
                                                          </tr>
                                                        </ng-template>
                                                      </p-table>
                                                    </div>
                                                  </div>
                                                </div>
                                              </p-tabPanel>
                                            }
                                          </p-tabView>
                                        </div>
                                      </div>
                                    </form>
                                  </p-dialog>


                                  @if (showCropperDialog) {
                                    <app-image-cropper [image]="currentSelectedImageToCrop" [showCropperDialog]="showCropperDialog"
                                      (onImageCropped)="onImageCropped($event)" (onImageCropperClose)="onImageCropperClose($event)">
                                    </app-image-cropper>
                                  }